export const GET_PENALTY_COMPUTATION_LIST =
  'DISCOUNT_PENALTY/get_penalty_computation_list';
export const GET_DISCOUNT_PENALTY_LIST =
  'DISCOUNT_PENALTY/get_discount_penalty_list';
export const UPDATE_DISCOUNT_PENALTY =
  'DISCOUNT_PENALTY/update_discount_penalty';

export const GET_FEE_CODES = 'GET_FEE_CODES/get_fee_codes';
export const GET_FEE_SETTINGS = 'GET_FEE_SETTINGS/get_fee_settings';
export const UPDATE_FEE_SETTINGS = 'UPDATE_FEE_SETTINGS/update_fee_settings';
export const GET_REVOKED_PERMIT_REAPPLICATION_OPTION_LIST = 'DISCOUNT_PENALTY/get_revoked_permit_reapplication_option_list';
export const GET_RETIRE_DELINQUENT_BUSINESS_OPTION_LIST =
  'DISCOUNT_PENALTY/get_retire_delinquent_business_option_list';
export const GET_PENALTY_DISPLAY_IN_OR = 'DISCOUNT_PENALTY/get_penalty_display_in_or';
export const GET_START_INTEREST_OPTION = 'DISCOUNT_PENALTY/get_start_interest_option';

export const FORM_DATA = {
  additional_monthly_penalty_percentage: '',
  date_before_penalty_start: '',
  discount_percentage: '',
  initial_penalty_percentage: '',
  last_date_with_discount: '',
  maximum_penalty_percentage: '',
  month_day_before_penalty_update: '',
  year: '',
  gross_additional_percentage: '',
  change_request_processing_fee: 0,
  retirement_processing_fee: 0,
  penalty_computation: 0,
  basis_of_penalty: '',
  essential_rate: '',
  revoked_permit_reapplication: 'allowed',
  retire_delinquent_business: 'allowed',
  penalty_display_in_or: 'penalty_included',
  start_of_interest: '',
  retention_rate: '',
  minimum_payable_amount: '',
  payment_reminder: 'no',
  payment_reminder_description: 'no',
  reminder_days_before_due_date: '',
  reminder_apply_in_renewal: 0,
  reminder_apply_in_quarterly: 0,
};

export const PAYMENT_REMINDER_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

export const BASIS_OF_PENALTY = [
  { label: 'Delinquency Period', value: 'Delinquency Period' },
  { label: 'SOA Amount', value: 'SOA Amount' },
];
